import { render, staticRenderFns } from "./availability-display-parameter.vue?vue&type=template&id=bad2447e&"
import script from "./availability-display-parameter.vue?vue&type=script&lang=js&"
export * from "./availability-display-parameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports